module.exports = __webpack_public_path__ + "static/media/logo.1e4081ce.png";